import { Component, inject, Input, OnInit } from "@angular/core";
import { NavController } from "@ionic/angular";
import { PointInfo } from "src/app/services/dto/orwi-user";
import { StoreService } from "src/app/services/store/store.service";
import { UserService } from "src/app/services/user/user.service";

@Component({
  selector: "coffee-seed",
  templateUrl: "./coffee-seed.component.html",
  styleUrls: ["./coffee-seed.component.scss"],
})
export class CoffeeSeedComponent implements OnInit {
  @Input() mode: "home" | "reservations" = "home";
  userService = inject(UserService)
  storeService = inject(StoreService)
  navController = inject(NavController)

  ngOnInit(): void {
     
  }

  toArr(num: number) {
    const result: number[] = [];
    for (let i = 0; i < num; i++) {
      result.push(i);
    }
    return result;
  }
}
